export default __webpack_public_path__ + "static/media/java-project-image.b03eca92.png";